/* Shop All UGC1 — carousels + size filter + Ship-to-me (frozen) toggle + sort.
   Operates on server-rendered cards (data attributes set by snippets/sa-ugc1-card.liquid).
   Ported from approved mockup v5. Ratings are hydrated separately by
   assets/component-caketrack-review-stats.js; once those load we refresh data-reviews
   so the "Most reviewed" sort uses real CakeTrack counts. */
(function () {
  var browse = document.querySelector('[data-sa-browse]');
  if (!browse) return;
  var grid = browse.querySelector('[data-sa-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-sa-card]'));
  cards.forEach(function (c, i) { c.dataset.order = i; });

  /* ---- per-card photo carousels (reusable so injected UGC tiles get swipe too) ---- */
  function initCarousel(car) {
    var track = car.querySelector('.sa-car-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(car.querySelectorAll('.sa-car-slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(car.querySelectorAll('.sa-dot'));
    var prev = car.querySelector('.prev');
    var next = car.querySelector('.next');
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }
    function cur() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      slides.forEach(function (s, i) {
        var sc = s.offsetLeft + s.clientWidth / 2 - slides[0].offsetLeft;
        var d = Math.abs(sc - c);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(i); }); });
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur() - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur() + 1); });
    var moved = false;
    track.addEventListener('touchmove', function () { moved = true; }, { passive: true });
    slides.forEach(function (s) { s.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } moved = false; }); });
    track.addEventListener('scroll', function () {
      var b = cur();
      dots.forEach(function (d, i) { d.classList.toggle('active', i === b); });
      if (prev) prev.disabled = b === 0;
      if (next) next.disabled = b === slides.length - 1;
    }, { passive: true });
  }
  browse.querySelectorAll('[data-sa-car]').forEach(initCarousel);

  /* ---- filter state (size buckets + ship-to-me/frozen; fixed small -> large order) ---- */
  var state = { size: 'all', ship: false };
  var chips = browse.querySelector('.sa-seg');
  var shipToggle = browse.querySelector('[data-sa-ship]');
  var countEl = browse.querySelector('[data-sa-count]');
  var emptyEl = browse.querySelector('[data-sa-empty]');

  function num(c, k) { return parseFloat(c.dataset[k] || 0) || 0; }

  // Explicit curated display order (pinned in the section setting) so the grid is
  // identical on localhost and production, regardless of how Shopify happens to
  // order the collection's products (the old serves-tie tiebreak depended on that
  // product order, which differs between the virtual /collections/all route and the
  // 'all' smart collection). Any handle not listed falls to the end, by serving size.
  var displayOrder = (grid.dataset.saOrder || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  function orderRank(c) { var i = displayOrder.indexOf(cardHandle(c)); return i === -1 ? 999 : i; }
  cards.slice()
    .sort(function (a, b) {
      return orderRank(a) - orderRank(b)
        || (num(a, 'serves') || 999) - (num(b, 'serves') || 999)
        || num(a, 'order') - num(b, 'order');
    })
    .forEach(function (c) { grid.appendChild(c); });

  function apply() {
    var visible = 0;
    cards.forEach(function (c) {
      var okSize = state.size === 'all' || c.dataset.bucket === state.size;
      if (c.dataset.ugc) {
        // woven review tiles: match active bucket; hide in ship view
        c.classList.toggle('sa-hide', !okSize || state.ship);
        return;
      }
      var okShip = !state.ship || c.dataset.frozen === 'true';
      var show = okSize && okShip;
      c.classList.toggle('sa-hide', !show);
      if (show) visible++;
    });
    if (countEl) countEl.textContent = 'Showing ' + visible + ' cake' + (visible === 1 ? '' : 's');
    if (emptyEl) emptyEl.hidden = visible !== 0;
  }

  if (chips) chips.addEventListener('click', function (e) {
    var b = e.target.closest('.sa-seg-btn');
    if (!b) return;
    chips.querySelectorAll('.sa-seg-btn').forEach(function (c) {
      c.classList.remove('active');
      c.setAttribute('aria-pressed', 'false');
    });
    b.classList.add('active');
    b.setAttribute('aria-pressed', 'true');
    state.size = b.dataset.saChip;
    apply();
  });
  if (shipToggle) shipToggle.addEventListener('change', function (e) { state.ship = e.target.checked; apply(); });
  apply();

  /* ---- reformat CakeTrack's "5.0 / 5" rating text down to the mockup's "5.0" once it hydrates ---- */
  function reformatRatings() {
    cards.forEach(function (c) {
      var numEl = c.querySelector('.sa-rate-num[data-review-rating-text]');
      if (numEl && numEl.textContent.indexOf('/') !== -1) {
        numEl.textContent = numEl.textContent.split('/')[0].trim();
      }
    });
  }
  // CakeTrack hydrates async; poll briefly then settle.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    reformatRatings();
    if (tries >= 6) clearInterval(timer);
  }, 600);

  /* ---- woven contextual UGC media tiles injected next to matching products ---- */
  function cardHandle(c) {
    if (c.dataset.productHandle) return c.dataset.productHandle;
    var a = c.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function cardFamilyCode(c) {
    return c && c.dataset ? String(c.dataset.familyCode || '').trim() : '';
  }
  // A swipeable review tile: a carousel of this product-family's curated media (a tease that
  // links to the PDP, where the full photo set lives). Reuses the card carousel markup.
  function tileHtml(reviews, card, handle) {
    var R = window.SaUgc1Reviews;
    var shop = 'Shop ' + R.shopLabel((card.querySelector('.sa-title') || {}).textContent || '');
    var multi = reviews.length > 1;
    var slides = reviews.map(function (rv) {
      var q = R.cleanQuote(rv.review_text, 46);
      return '<a class="sa-car-slide" href="/products/' + R.esc(handle) + '">' +
        '<img src="' + R.esc(rv.photo_urls[0]) + '" alt="" loading="lazy">' +
        '<span class="sa-rtile__ov">' +
          '<span class="sa-rtile__stars" aria-hidden="true">★★★★★</span>' +
          (q ? '<span class="sa-rtile__q">“' + R.esc(q) + '”</span>' : '') +
          '<span class="sa-rtile__name">' + R.esc(window.transformReviewName(rv.reviewer_display_name, 'Buyer')) + ', verified buyer</span>' +
          '<span class="sa-rtile__shop">' + R.esc(shop) + '</span>' +
        '</span></a>';
    }).join('');
    var dots = multi ? '<div class="sa-car-dots">' + reviews.map(function (_, i) {
      return '<button class="sa-dot' + (i === 0 ? ' active' : '') + '" aria-label="Photo ' + (i + 1) + '"></button>';
    }).join('') + '</div>' : '';
    var arrows = multi ? '<button class="sa-car-arrow prev" aria-label="Previous" disabled>‹</button><button class="sa-car-arrow next" aria-label="Next">›</button>' : '';
    return '<span class="sa-rtile__tag">★ Real review</span>' +
      '<div class="sa-car sa-rtile__car" data-sa-car><div class="sa-car-track">' + slides + '</div>' + arrows + dots + '</div>';
  }
  function buildTile(reviews, card, handle) {
    var wrap = document.createElement('div');
    wrap.className = 'sa-card sa-rtile';
    wrap.setAttribute('data-sa-card', '');
    wrap.setAttribute('data-ugc', '1');
    wrap.dataset.bucket = card.dataset.bucket;
    wrap.dataset.serves = card.dataset.serves;
    wrap.dataset.frozen = card.dataset.frozen;
    wrap.dataset.productHandle = handle;
    wrap.innerHTML = tileHtml(reviews, card, handle);
    return wrap;
  }
  if (window.SaUgc1Reviews) {
    var featured = (grid.dataset.saFeatured || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    featured.forEach(function (handle) {
      var card = cards.filter(function (c) { return !c.dataset.ugc; }).find(function (c) { return cardHandle(c) === handle; });
      if (!card) return;
      var slot = cards.find(function (c) { return c.hasAttribute('data-sa-ugc-slot') && c.dataset.productHandle === handle; });
      var family = cardFamilyCode(card) || cardFamilyCode(slot);
      if (!family) {
        if (slot) slot.classList.add('sa-hide');
        return;
      }
      // curated UGC media from CakeTrack; take up to 4 to swipe
      window.SaUgc1Reviews.get(family, 6).then(function (reviews) {
        var top = reviews.slice(0, 4);
        if (!top.length) {
          if (slot) slot.classList.add('sa-hide');
          return;
        }
        if (slot) {
          slot.innerHTML = tileHtml(top, card, handle);
          slot.classList.remove('sa-rtile--loading');
          slot.removeAttribute('aria-hidden');
          initCarousel(slot.querySelector('[data-sa-car]'));
          apply();
          return;
        }
        var tile = buildTile(top, card, handle);
        card.insertAdjacentElement('beforebegin', tile);
        initCarousel(tile.querySelector('[data-sa-car]'));
        cards.push(tile);
        apply();
      });
    });
  }
})();
